import { AddressBaseInterface } from 'types';

import { get, post } from './axios';

const URLS = {
  getAddresses: 'get-cl-addresses',
  updateAddress: 'update-cl-address',
  addAddress: 'add-cl-address',
  deleteAddress: 'del-cl-address'
};

const cardsApi = {
  getAddresses: () => get(URLS.getAddresses),
  updateAddress: (address: AddressBaseInterface) =>
    post(URLS.updateAddress, address),
  addAddress: (address: AddressBaseInterface) => post(URLS.addAddress, address),
  deleteAddress: (addressId: number) =>
    get(URLS.deleteAddress, { addr_id: addressId })
};

export default cardsApi;
